


import {Component, Emit, Model, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class AppRadio extends Vue {

  @Model('change', {default: false})
  public value!: boolean;

  @Prop({default: null})
  public label!: string;

  @Prop({default: 'default'})
  public name!: string;

  @Prop({default: false})
  public disabled!: boolean;

  @Emit('change')
  public emitChange(): boolean {
    return this.isChecked;
  }

  public id: string = [this.name, new Date().getTime(), Math.random()].join('-');
  private isChecked: boolean = false;
  private elementContainingOtherRadioButtons: HTMLElement | null = null;

  public mounted(): void {
    this.isChecked = this.value;
    this.setElementContainingOtherRadioButtons();
    if (this.elementContainingOtherRadioButtons) {
      this.elementContainingOtherRadioButtons.addEventListener('change', this.onGlobalChangeEvent.bind(this));
    }
  }

  public beforeDestroy(): void {
    if (this.elementContainingOtherRadioButtons) {
      this.elementContainingOtherRadioButtons.removeEventListener('change', this.onGlobalChangeEvent.bind(this));
    }
  }

  private onGlobalChangeEvent(event: any): void {
    if (event.target && event.target.name === this.name) {
      this.isChecked = event.target.id === this.id;
      this.emitChange();
    }
  }

  private setElementContainingOtherRadioButtons(): void {
    const radioButtonContainer: HTMLElement = this.$refs['container'] as HTMLElement;
    let parent: HTMLElement | null = radioButtonContainer.parentElement;
    for (let i = 0; i <= 10; i++) {
      if (!parent) {
        break;
      }
      if (parent.querySelectorAll('.radio-component').length > 1) {
        this.elementContainingOtherRadioButtons = parent;
        break;
      }
      parent = parent.parentElement;
    }
  }
}
